import script from "./SuperAdminViewAllTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperAdminViewAllTalks.vue?vue&type=script&setup=true&lang=js"

import "./SuperAdminViewAllTalks.vue?vue&type=style&index=0&id=bc8b19a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc8b19a4"]])

export default __exports__